// This must be imported FIRST before any other imports
// It sets the webpack public path dynamically at runtime
if (window.__CDN_PUBLIC_PATH__ && process.env.NODE_ENV !== 'development') {
  __webpack_public_path__ = window.__CDN_PUBLIC_PATH__ + '/';
}
export {};
